import React, { Fragment } from "react";
import { connect } from "react-redux";

import Hamburger from "hamburger-react";

import cx from "classnames";

import {
  CSSTransition,
  TransitionGroup,
} from "../../../utils/TransitionWrapper";

import {
  setEnableMobileMenu,
  setEnableMobileMenuSmall,
} from "../../../reducers/ThemeOptions";
import UserBox from "./UserBox";

type Props = {
  enableMobileMenu: boolean;
  setEnableMobileMenu: (v: boolean) => any;
  enableMobileMenuSmall: boolean;
  setEnableMobileMenuSmall: (v: boolean) => any;
};

type State = {
  active: boolean;
  mobile: boolean;
  activeSecondaryMenuMobile: boolean;
  openLeft: boolean;
  openRight: boolean;
  relativeWidth: boolean;
  width: number;
  noTouchOpen: boolean;
  noTouchClose: boolean;
};

class AppMobileMenu extends React.Component<Props, State> {
  state: State = {
    active: false,
    mobile: false,
    activeSecondaryMenuMobile: false,
    openLeft: false,
    openRight: false,
    relativeWidth: false,
    width: 280,
    noTouchOpen: false,
    noTouchClose: false,
  };

  toggleMobileSidebar = () => {
    this.props.setEnableMobileMenu(!this.props.enableMobileMenu);
  };

  toggleMobileSmall = () => {
    this.props.setEnableMobileMenuSmall(!this.props.enableMobileMenuSmall);
  };

  render() {
    return (
      <Fragment>
          <div className="app-header__mobile-menu" key="mobile-menu-toggle">
            <div onClick={this.toggleMobileSidebar}>
              <Hamburger
                toggled={this.props.enableMobileMenu}
                toggle={this.toggleMobileSidebar}
                size={26}
                color="#eaeaeaff"
              />
            </div>
          </div>
          <div className="app-header__menu" key="mobile-menu-userbox">
            <div className="app-header-right">
              <UserBox />
            </div>
          </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = (dispatch: any) => ({
  setEnableMobileMenu: (enable: any) => dispatch(setEnableMobileMenu(enable)),
  setEnableMobileMenuSmall: (enable: any) =>
    dispatch(setEnableMobileMenuSmall(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppMobileMenu);
